<div class="table-view-list">
    <div class="top-row-container">
        <div class="add-new-button">
            <app-button
                [buttonType]="'secondary'"
                [leftIcon]="'plus'"
                [label]="'ruleTemplate.' + this.mode + '.list.button.new' | translate"
                (clickEmitter)="openRuleTemplateDialog()"
            ></app-button>
        </div>

        <mat-radio-group
            class="published-toggle"
            [(ngModel)]="mode"
            (change)="updateRuleMode($event)">

            @for (modus of allModi; track modus) {
                <mat-radio-button [value]="modus">
                    {{ "ruleTemplate.mode." + modus | translate }}
                </mat-radio-button>
            }
        </mat-radio-group>
    </div>

    <table mat-table [dataSource]="currentRuleTemplates" class="mat-elevation-z0" matSort
           (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'ruleTemplate.' + this.mode + '.list.column.id' | translate }}
            </th>
            <td mat-cell *matCellDef="let ruleTemplate"> {{ ruleTemplate.id }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'ruleTemplate.' + this.mode + '.list.column.name' | translate }}
            </th>
            <td mat-cell *matCellDef="let ruleTemplate"> {{ ruleTemplate.name }}</td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'ruleTemplate.' + this.mode + '.list.column.action' | translate }}
            </th>
            <td mat-cell *matCellDef="let ruleTemplate">
                <div class="container">
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'ruleTemplate.tooltips.copy' | translate"
                            (click)="openRuleTemplateDialog(ruleTemplate, true)">
                        <mat-icon class="icon">content_copy</mat-icon>
                    </button>
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'buttons.edit' | translate"
                            (click)="openRuleTemplateDialog(ruleTemplate)">
                        <mat-icon class="icon">edit</mat-icon>
                    </button>
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'ruleTemplate.tooltips.editRule' | translate"
                            (click)="openEditRuleDialog(ruleTemplate, this.mode)">
                        <mat-icon class="icon">terminal</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

</div>
